import React, { useState } from "react";
import "./index.css";

function SubmittionForm({ isOpen, onClose, eventSource = "" }) {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    gender: "",
    school: "",
    city: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const validate = () => {
    const newErrors = {};
    const phoneRegex = /^[6-9]\d{9}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.phone.trim()) newErrors.phone = "Phone is required";
    else if (!phoneRegex.test(formData.phone))
      newErrors.phone = "Invalid phone number";

    if (!formData.email.trim()) newErrors.email = "Email is required";
    else if (!emailRegex.test(formData.email))
      newErrors.email = "Invalid email format";

    if (!formData.gender) newErrors.gender = "Please select gender";
    if (!formData.school.trim()) newErrors.school = "School is required";
    if (!formData.city.trim()) newErrors.city = "City is required";

    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validate();

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setLoading(true);
    const scriptURL =
      "https://script.google.com/macros/s/AKfycbzfjPa2uRnydEiI4AG3Xjywx7DMRG-8C0oBwp7bBkqro9m_IvBlONwg4pu_4OcY1nOW/exec";

    try {
      const res = await fetch(scriptURL, {
        method: "POST",
        body: JSON.stringify({ ...formData, source: eventSource }),
        // body: (`name=${formData.name}&phone=${formData.phone}&email=${formData.email}&gender=${formData.gender}&school=${formData.school}&city=${formData.city}`),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          // "Content-Type": "application/json"
        },
      });

      const result = await res.json();
      if (result.status === "success") {
        setFormData({
          name: "",
          phone: "",
          email: "",
          gender: "",
          school: "",
          city: "",
        });
        setIsSubmitted(true);
      }
    } catch (error) {
      alert("Failed to submit form.");
      console.error(error);
    } finally {
      setLoading(false); // ✅ Stop loader
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <button
            className="close-btn"
            onClick={() => {
              setIsSubmitted(false);
              setErrors({});
              onClose();
            }}
          >
            ×
          </button>
          <h2 className="modal-heading">
            {isSubmitted ? (
              "Thank You!"
            ) : (
              <>
                <p>Apply to Participate in</p>
                {/* <br /> */}
                <span>OxfordMUN India 2025</span>
              </>
            )}
          </h2>
        </div>

        <div className="modal-body">
          {isSubmitted ? (
            <div className="thank-you-message">
              <p>Thank you for submitting the form! 🎉</p>
              <p>We will get in touch with you soon.</p>
            </div>
          ) : (
            <form className="form" onSubmit={handleSubmit} noValidate>
              {/* Name */}
              <div className="input-group">
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Jack Sullivan"
                  required
                />
                <label>Name</label>
                {errors.name && <small className="error">{errors.name}</small>}
              </div>

              {/* Phone */}
              <div className="input-group phone-input">
                <label>Phone</label>
                <div className="phone-wrapper">
                  <div className="split-input">
                    <input type="text" value="+91" disabled />
                  </div>
                  <div className="split-input">
                    <input
                      type="text"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="9876543210"
                      required
                    />
                  </div>
                </div>
                {errors.phone && (
                  <small className="error">{errors.phone}</small>
                )}
              </div>

              {/* Email */}
              <div className="input-group">
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="jack.s@gmail.com"
                  required
                />
                <label>Email</label>
                {errors.email && (
                  <small className="error">{errors.email}</small>
                )}
              </div>

              {/* Gender */}
              <div className="input-group">
                <select
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select</option>
                  <option>Male</option>
                  <option>Female</option>
                  <option>Other</option>
                </select>
                <label>I am a</label>
                {errors.gender && (
                  <small className="error">{errors.gender}</small>
                )}
              </div>

              {/* School */}
              <div className="input-group">
                <input
                  type="text"
                  name="school"
                  value={formData.school}
                  onChange={handleChange}
                  placeholder=""
                  required
                />
                <label>Your School</label>
                {errors.school && (
                  <small className="error">{errors.school}</small>
                )}
              </div>

              {/* City */}
              <div className="input-group">
                <input
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  placeholder="Delhi"
                  required
                />
                <label>City</label>
                {errors.city && <small className="error">{errors.city}</small>}
              </div>

              <button type="submit" className="submit-btn" disabled={loading}>
                {loading ? (
                  <>
                    Submitting <span className="loader" />
                  </>
                ) : (
                  "Submit"
                )}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default SubmittionForm;
